module.exports = {
  modal: {
    alert: 'Alert',
    confirm: 'Confirm'
  }
}



// WEBPACK FOOTER //
// ./~/rctui/lang/en/modal.js